module.exports = __webpack_public_path__ + "img/history13.4b6e7974.jpg";